import { SUPPORT_EMAIL } from './constants';

export const getSupportMailto = (userId?: number, familyAccountId?: number) => {
	const isDisplayUserInfo = userId && familyAccountId;
	const query = isDisplayUserInfo ? `?body=user id: ${userId}%0Afamily account id: ${familyAccountId}` : '';
	return `mailto:${SUPPORT_EMAIL}${query}`;
};
